/**
 * Filtro One Euro (Casiez et al., 2012): suaviza mucho cuando la señal está quieta (quita el
 * temblor de los puntos clave) y casi nada cuando se mueve rápido (no añade retraso a un salto).
 *   minCutoff: frecuencia de corte en reposo (Hz). Menor = más suave en reposo.
 *   beta: cuánto sube el corte con la velocidad. Mayor = menos retraso en movimientos rápidos.
 */
export class OneEuro {
  constructor(minCutoff = 1, beta = 0, dCutoff = 1) {
    this.minCutoff = minCutoff;
    this.beta = beta;
    this.dCutoff = dCutoff;
    this.reset();
  }

  reset() {
    this.x = null;
    this.dx = 0;
    this.t = 0;
  }

  /** Filtra el valor x medido en el instante t (segundos). */
  filter(x, t) {
    if (this.x === null) {
      this.x = x;
      this.t = t;
      return x;
    }
    const dt = Math.max(1e-3, t - this.t);
    this.t = t;
    const dx = (x - this.x) / dt;
    this.dx += alpha(this.dCutoff, dt) * (dx - this.dx);
    const cutoff = this.minCutoff + this.beta * Math.abs(this.dx);
    this.x += alpha(cutoff, dt) * (x - this.x);
    return this.x;
  }
}

function alpha(cutoff, dt) {
  const tau = 1 / (2 * Math.PI * cutoff);
  return 1 / (1 + tau / dt);
}
